/** @type {import("tailwindcss").Config} */
const { createThemes } = require("tw-colors");

module.exports = {
  content: [
    "./src/pages/**/*.{ts,tsx}",
    "./src/components/**/*.{ts,tsx}",
    "./src/app/**/*.{ts,tsx}",
    "./node_modules/react-tailwindcss-datepicker/dist/index.esm.js",
    "../../node_modules/react-tailwindcss-datepicker/dist/index.esm.js",
    "../../packages/ui/**/!(node_modules)/*.{ts,tsx}",
  ],
  theme: {
    screens: {
      xs: "320px",
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
      "3xl": "2048px",
    },
    extend: {
      backgroundImage: {
        "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
        "gradient-conic":
          "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
      },
    },
  },
  plugins: [
    require("daisyui"),
    createThemes({
      Memoring: {
        "purple-550": "#9c88bf",
        "purple-700": "#7641d0",
        "purple-950": "#4710a5",
        "purple-1000": "#3b0764",
        "purple-1050": "#342a55",
        "gray-300": "#d0d0d0",
        "gray-350": "#b8bdc5",
        alertbackg: "#f4f5f7",
        green: "#34e309",
        primaryColor: "#d89f4a",
        hoverColor: "#d89f4a",
        lightColor: "#F8F0E5",
        darkColor: "#EADBC8",
        newPurple: "#5E17EB",
        selectedPriceCardRow: "#C1FF72",
        memoringGold: "#d89f4a",
        memoRed: "#E60000",
        brownMild: "#d9c1a7",
        navy: "#243B4A",
        blue: "#788FA1",
        purple: "#806375",
        pink: "#E8C7C7",
        tan: "#C7B8B0",
        brownDarker: "#3B2411",
        greenAttention: "#00bf63",
        orange: "#f9af40",
        brand100: "#f7ce83",
        brand200: "#f4b85f",
        brand300: "#d89f4a",

        brandNeutral100: "#fbe9d1",
        brandNeutral200: "#fde6db",
        brandNeutral300: "#f5e9dc",
        brandNeutral400: "#fff3e7",
        brandNeutral500: "#fdeac8",
        brandNeutral600: "#f5a18c",

        brandAccent700: "#a76415",
        brandAccent800: "#724715",

        brandSuccess100: "#cae2d7",
        brandSuccess200: "#add0bf",
        brandSuccess300: "#6e9e86",
        headerColor: "#6e9e86",
        sidebarColor: "#6e9e86",
        pageBackgroundColor: "#f5f0eb",
        cardSectionColor: "#fcfbfa",
        textColor: "#1E1A16",
        iconColor: "#C9A876",
        borderColor: "#B88F54",
      },
      EventJinny: {
        "purple-550": "#9c88bf",
        "purple-700": "#7641d0",
        "purple-950": "#4710a5",
        "purple-1000": "#3b0764",
        "purple-1050": "#342a55",
        "gray-300": "#d0d0d0",
        "gray-350": "#b8bdc5",
        alertbackg: "#f4f5f7",
        green: "#34e309",
        primaryColor: "#102c57",
        hoverColor: "#102c57",
        lightColor: "#F8F0E5",
        darkColor: "#EADBC8",
        newPurple: "#5E17EB",
        "brown-light": "#DCC3A8",
        "brown-mild": "#8D7665",
        "blue-neon": "#5E17EB",
        "green-neon": "#C1FF72",
        sunset: "#8D7665",
        newGreen: "#7ED957",
        selectedPriceCardRow: "#C1FF72",
        navy: "#243B4A",
        blue: "#788FA1",
        purple: "#806375",
        pink: "#E8C7C7",
        tan: "#C7B8B0",
        brown: "#A38F80",
        brownMild: "#d9c1a7",
        brownDarker: "#3B2411",
        greenAttention: "#00bf63",
        orange: "#f9af40",
        brand100: "#102c57",
        brand200: "#102c57",
        brand300: "#102c57",

        brandNeutral100: "#fbe9d1",
        brandNeutral200: "#fde6db",
        brandNeutral300: "#f5e9dc",
        brandNeutral400: "#fff3e7",
        brandNeutral500: "#fdeac8",
        brandNeutral600: "#f5a18c",

        brandAccent700: "#a76415",
        brandAccent800: "#724715",

        brandSuccess100: "#cae2d7",
        brandSuccess200: "#add0bf",
        brandSuccess300: "#6e9e86",
        headerColor: "#374151",
        sidebarColor: "#374151",
        pageBackgroundColor: "#F2F3F5",
        cardSectionColor: "#F9FBFC",
        textColor: "#36312E",
        iconColor: "#a76415",
        borderColor: "#102c57",
      },
    }),
  ],
  daisyui: {
    themes: [
      {
        mytheme: {
          primary: "#102C57",
          secondary: "#4edb7b",
          accent: "#5E17EB",
          neutral: "#8D7665",
          "base-100": "#edf0f2",
          info: "#DCC3A8",
          success: "#00bf63",
          warning: "#f8bb49",
          error: "#ae0000",
          brownLight: "#DCC3A8",
          brownMild: "#8D7665",
          blueNeon: "#5E17EB",
          greenNeon: "#C1FF72",
          sunset: "#8D7665",
          memoringGold: "#d89f4a",
        },
      },
    ],
    logs: false,
  },
};
